import { Component, OnInit, inject } from '@angular/core';

import { RouterLink, ActivatedRoute } from '@angular/router';
import { QrStateService } from '../services/qr-state.service';

@Component({
  selector: 'app-payment-success',
  standalone: true,
  imports: [RouterLink],
  template: `
    <main class="min-h-screen bg-gray-950 text-gray-100 flex items-center justify-center px-4">
      <div class="w-full max-w-md">
        <div class="relative overflow-hidden rounded-2xl bg-gradient-to-br from-green-500 via-green-400 to-emerald-400 p-8 text-gray-950 shadow-2xl">
          <div class="flex flex-col items-center text-center">
            <!-- Success Icon -->
            <div class="mb-6 grid h-20 w-20 place-items-center rounded-full bg-white/30 text-5xl">
              <span class="material-symbols-outlined text-5xl">check</span>
            </div>

            <h1 class="text-3xl font-bold mb-3">Zahlung erfolgreich!</h1>
            <p class="text-lg text-gray-900/90 mb-6">
              Vielen Dank für deine Bestellung. Wir haben deine Zahlung erhalten und bereiten deine Bestellung vor.
            </p>

          </div>
        </div>

        <div class="mt-6 rounded-xl border border-gray-800 bg-gray-900 p-6">
          <h2 class="text-lg font-semibold mb-3">Was passiert jetzt?</h2>
          <ul class="space-y-2 text-sm text-gray-400">
            <li class="flex items-start gap-2">
              <span class="text-green-500 material-symbols-outlined">check</span>
              <span>Deine Bestellung wurde erfolgreich aufgegeben</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-green-500 material-symbols-outlined">check</span>
              <span>Die Zahlung wurde bestätigt</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-orange-500 material-symbols-outlined">arrow_forward</span>
              <span>Deine Bestellung wird jetzt zubereitet</span>
            </li>
          </ul>
        </div>

        <div class="mt-6 flex flex-col gap-3">
          <a
            routerLink="/"
            class="w-full inline-flex items-center justify-center rounded-xl bg-orange-500 px-6 py-3 text-base font-medium text-white transition hover:bg-orange-400"
          >
            Zurück zur Speisekarte
          </a>

          <button
            class="w-full inline-flex items-center justify-center rounded-xl border border-gray-700 bg-gray-900 px-6 py-3 text-base font-medium text-gray-300 transition hover:bg-gray-800"
            (click)="clearCart()"
          >
            Warenkorb leeren
          </button>
        </div>

        <div class="mt-6 text-center text-xs text-gray-500">
          Bei Fragen zu deiner Bestellung wende dich bitte an das Personal.
        </div>
      </div>
    </main>
  `,
})
export class PaymentSuccessComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private qrState = inject(QrStateService);
  sessionId: string | null = null;

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.sessionId = params['session_id'] || null;
      console.log('Payment success - Session ID:', this.sessionId);
    });

    this.qrState.initializeFromUrl(this.route);
    this.clearCart();
  }

  clearCart() {
    try {
      localStorage.removeItem('cart');
      localStorage.removeItem('cartCount');
      console.log('Cart cleared after successful payment');
    } catch (e) {
      console.error('Failed to clear cart:', e);
    }
  }
}
